module.exports = __webpack_public_path__ + "static/media/break.26ae4a88.svg";